import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Message, Form, Button, Modal, Icon, Input,
} from 'semantic-ui-react';

import './preferencesStyle.css';
import { isEmpty } from 'lodash';
import localStore from 'store';
import subscriptionPreferenceQuery from '../../../graphql/subscriptionPreferenceQuery';
import preferencesDiscoverQuery from '../../../graphql/preferencesDiscoverQuery';

import client from '../../../apollo';

import Preference from './Preference';

import { utcMoment } from '../../../utilities/dateUtils';
import { isValidFacts } from '../../../utilities/preferenceUtil';
import { formatSubscriptionType } from '../../../constants/subscriptions';

class SubscriptionPreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preferenceLoaded: false,
      preferenceDiscoverLoaded: true,
      isSubmitting: false,
    };
  }

  componentDidMount() {
    const { subscription } = this.props;
    this.getSubscriptionPreferenceQuery(subscription);
    this.getPreferencesDiscoverQuery();
  }

  getSubscriptionPreferenceQuery = subscription => {
    client
      .query({
        query: subscriptionPreferenceQuery,
        variables: {
          subscriptionId: parseInt(subscription.subscription_id, 10),
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        const { subscriptionPreference } = data;

        if (isEmpty(subscriptionPreference)) {
          localStore.set('preference', {});
        } else {
          localStore.set('preference', subscriptionPreference);
          this.setState({ preferenceLoaded: true });
        }
      })
      .catch(() => {
        localStore.set('preference', {});
      });
  };

  getPreferencesDiscoverQuery = () => {
    client
      .query({
        query: preferencesDiscoverQuery,
      })
      .then(({ data }) => {
        const { preferencesDiscover } = data;
        if (isEmpty(preferencesDiscover)) {
          localStore.set('preferenceDiscover', preferencesDiscover);
        } else {
          localStore.set('preferenceDiscover', preferencesDiscover);
          this.setState({ preferenceDiscoverLoaded: true });
        }
      })
      .catch(() => {
        localStore.set('preferenceDiscover', {});
      });
  };

  onSaveHandler = () => {
    const { onSubmitHandler } = this.props;

    const data = localStore.get('preference') || {};
    const isEmptyRuleOrOperatorTypeOrFact = data.ruleList.filter(
      rule => rule.ruleType === ''
        || rule.operatorType === ''
        || rule.facts.length === 0
        || rule.facts === ''
        || !isValidFacts(rule.facts, rule.ruleType)
    );

    const isEmptyDefaultRule = data.ruleSetList.filter(
      defaultRule => defaultRule.defaultPreferenceRuleType === ''
    );

    if (
      !isEmpty(isEmptyRuleOrOperatorTypeOrFact)
      || !isEmpty(isEmptyDefaultRule)
    ) {
      this.setState({ isSubmitting: true });
      return false;
    }

    onSubmitHandler();
    return true;
  };

  render() {
    const {
      isModalOpen, onCloseHandler, error, submitting,
    } = this.props;

    const { preferenceLoaded, preferenceDiscoverLoaded, isSubmitting } = this.state;

    const preference = localStore.get('preference') || {};
    const { startDate } = preference;
    const { preferenceType } = preference;

    return (
      preferenceLoaded
      && preferenceDiscoverLoaded && (
        <Modal
          open={isModalOpen}
          closeIcon
          onClose={onCloseHandler}
          closeOnEscape={false}
          closeOnRootNodeClick={false}
          className='preferences'
        >
          <Modal.Content image>
            <Modal.Description>
              {error && (
                <Message negative>
                  <p>{error}</p>
                </Message>
              )}
              <Form>
                <Form.Group widths='equal'>
                  <Form.Field style={{ width: '50%' }}>
                    <label htmlFor='startDate'>Start Date</label>

                    <Input
                      id='startDate'
                      placeholder='YYYY-MM-DD'
                      value={
                        isEmpty(startDate)
                          ? ''
                          : utcMoment(startDate).format('YYYY-MM-DD')
                      }
                      disabled
                    />
                  </Form.Field>

                  <Form.Field style={{ width: '50%' }}>
                    <label htmlFor='preferenceType'>Preference Type</label>
                    <Input
                      id='preferenceType'
                      placeholder='Preference Type'
                      value={formatSubscriptionType(preferenceType)}
                      disabled
                    />
                  </Form.Field>
                </Form.Group>
              </Form>

              <Form>
                <Preference isSubmitting={isSubmitting} />
              </Form>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            {submitting && (
              <Button loading positive>
                Submitting...
              </Button>
            )}
            {!submitting && (
              <Button
                color='green'
                inverted
                onClick={this.onSaveHandler}
              >
                <Icon name='checkmark' /> Save
              </Button>
            )}
            <Button onClick={onCloseHandler}>Close</Button>
          </Modal.Actions>
        </Modal>
      )
    );
  }
}

SubscriptionPreferences.propTypes = {
  subscription: PropTypes.shape({
    subscription_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onSubmitHandler: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

SubscriptionPreferences.defaultProps = {
  subscription: {},
  isModalOpen: false,
  error: null,
  submitting: false,
};

export default SubscriptionPreferences;
